import { render, staticRenderFns } from "./FleetType.vue?vue&type=template&id=72c029d8&"
import script from "./FleetType.vue?vue&type=script&lang=js&"
export * from "./FleetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports